import {Transaction} from 'organization/Invoices/Transactions/OrganizationTransactionsProvider'
import React, {useState} from 'react'

export interface InvoicesModalsContextProps {
  createInvoiceModalOpen: boolean
  setCreateInvoiceModalOpen: (set: boolean) => void
  createInvoiceSelectedTransaction: Transaction | undefined
  setCreateInvoiceSelectedTransaction: (
    transaction: Transaction | undefined,
  ) => void
}

export const InvoicesModalsContext = React.createContext<
  InvoicesModalsContextProps | undefined
>(undefined)

export default function InvoicesModalsProvider(props: {
  children: React.ReactElement
}) {
  const [createInvoiceModalOpen, setCreateInvoiceModalOpen] = useState(false)
  const [
    createInvoiceSelectedTransaction,
    setCreateInvoiceSelectedTransaction,
  ] = useState<Transaction | undefined>(undefined)

  return (
    <InvoicesModalsContext.Provider
      value={{
        createInvoiceModalOpen,
        setCreateInvoiceModalOpen,
        createInvoiceSelectedTransaction,
        setCreateInvoiceSelectedTransaction,
      }}
    >
      {props.children}
    </InvoicesModalsContext.Provider>
  )
}

export function useInvoicesModals() {
  const context = React.useContext(InvoicesModalsContext)
  if (context === undefined) {
    throw new Error(
      'useInvoicesModals must be used within InvoicesModalsProvider',
    )
  }
  return context
}
